import React from 'react';
import { fieldNames } from '../../../common/config';
import { Form } from 'antd';
import { DatePickerCustom } from '../../../../../../../components/DatePickerCustom';
import { compareToStartDate } from '../../../common/lib/fieldValidators';

const endDateFieldName = fieldNames.endDate;
const FormItem = Form.Item;

const EndDateField = ({ form }) => {
  return (
    <FormItem
      label="Дата завершения (факт)"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(endDateFieldName, {
        rules: [{ validator: compareToStartDate(form) }],
      })(
        <DatePickerCustom
          size="large"
          style={{ width: '100%' }}
          placeholder="DD.MM.YYYY HH:mm"
          format="DD.MM.YYYY HH:mm"
          showTime={{ format: 'HH:mm', minuteStep: 10 }}
        />
      )}
    </FormItem>
  );
};

export default EndDateField;
